import { RealTimeSttSegmentMap } from '../../../types'
import { CreateRemarkAfterOperation, createRemarkAfterTransaction } from './create-remark-after-operation'
import { CreateRemarkAtPauseOperation, createRemarkAtPauseTransaction } from './create-remark-at-pause-operation'
import { CreateRemarkBeforeOperation, createRemarkBeforeTransaction } from './create-remark-before-operation'
import { DeleteRemarkOperation, deleteRemarkTransaction } from './delete-remark-operation'
import {
  EditRemarkBoundingTimesOperation,
  editRemarkBoundingTimesTransaction,
} from './edit-remark-bounding-times-operation'
import { EditRemarkTextOperation, editRemarkTextTransaction } from './edit-remark-text-operation'
import { MergeRemarkOperation, mergeRemarkTransaction } from './merge-remark-operation'
import { OperationResult } from './operation-result'
import { SplitRemarkOperation, splitRemarkOperationTransaction } from './split-remark-operation'
import { UpdateRemarkSpeakerOperation, updateRemarkSpeakerTransaction } from './update-remark-speaker-operation'

export type SttEditOperation =
  | EditRemarkTextOperation
  | CreateRemarkAfterOperation
  | CreateRemarkBeforeOperation
  | SplitRemarkOperation
  | DeleteRemarkOperation
  | MergeRemarkOperation
  | UpdateRemarkSpeakerOperation
  | EditRemarkBoundingTimesOperation
  | CreateRemarkAtPauseOperation

type OperationResolver<T extends SttEditOperation> = (op: T, map: RealTimeSttSegmentMap) => OperationResult

const operationToTransaction: {
  [K in SttEditOperation['type']]: OperationResolver<Extract<SttEditOperation, { type: K }>>
} = {
  createRemarkAfter: createRemarkAfterTransaction,
  createRemarkBefore: createRemarkBeforeTransaction,
  editRemarkText: editRemarkTextTransaction,
  splitRemark: splitRemarkOperationTransaction,
  deleteRemark: deleteRemarkTransaction,
  mergeRemark: mergeRemarkTransaction,
  updateRemarkSpeaker: updateRemarkSpeakerTransaction,
  editRemarkBoundingTimes: editRemarkBoundingTimesTransaction,
  createRemarkAtPause: createRemarkAtPauseTransaction,
}

export function sttEditOperationToTransaction(
  operation: SttEditOperation,
  segmentMap: RealTimeSttSegmentMap,
): OperationResult {
  return getResolverForType(operation.type)(operation, segmentMap)
}

function getResolverForType<T extends SttEditOperation['type']>(
  type: T,
): OperationResolver<Extract<SttEditOperation, { type: T }>> {
  return operationToTransaction[type]
}

// This is used to separate fragments visually in the editor. For english this is a space, but chinese or other languages might use a zero width space
export const STT_FRAGMENT_SEPARATOR = ' '
